import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlastEmailComponent } from './blastemail/blastemail.component';

const routes: Routes = [
    { path: 'livewire', component: BlastEmailComponent }, // TODO will delete this when finished. Will add this back in 19.2.
    // follow app routing format, in order to correspond with angular 10
    { path: 'intralinks/:id', loadChildren: () => import('./intralinks/intralinks.module').then(m => m.IntralinksModule) },
    { path: '', redirectTo: 'livewire', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FeedsRoutingModule { }
